// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"5198ad72","188":"5c639a40","856":"b71d8a9c"}[chunkId] + ".js";
};